import { Report57Component } from "../../../components/SupportSystem/Reports/Report57Component";
// import { NavbarComponent } from "../../../components/share/NavbarComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function Report57Container() {
    const titleName = "สรุปการใช้จ่ายเงินกองทุนพัฒนาฝีมือแรงงานเพื่อช่วยเหลือหรืออุดหนุน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <Report57Component/>
            <Footer />
        </div>   
        // 
    )
    
}